import { LineLoading } from "@/components/loading";
import { useAuthReady, useUserToken } from "@/store/userStore";
import { Navigate } from "react-router";

type Props = {
	children: React.ReactNode;
};

export default function LoginAuthGuard({ children }: Props) {
	const authReady = useAuthReady();
	const { accessToken } = useUserToken();

	if (!authReady) {
		return <LineLoading />;
	}

	if (!accessToken) {
		return <Navigate to="/auth/login" replace />;
	}

	return <>{children}</>;
}
